import { AdminSidebar } from "@/components/AdminSidebar";
import { useAdminAuth } from "@/contexts/useAdminAuth";
import { canAccessAdminPage, defaultAdminPage } from "@/lib/admin-access";
import { AccessDeniedPage } from "@/pages/AccessDeniedPage";
import { Navbar, SidebarLayout } from "@a7y/tailwind-catalyst";
import { SignedIn, SignedOut } from "@clerk/clerk-react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export function AdminLayout() {
  const { loading, role } = useAdminAuth();
  const { pathname } = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-gray-300 dark:border-zinc-600 border-t-blue-600"></div>
          <p className="text-gray-600 dark:text-zinc-400">Loading...</p>
        </div>
      </div>
    );
  }

  // A7Y-4957: a limited role lands on its own default page from `/admin`, and
  // any other page outside its scope shows the access-denied view in the shell.
  const isAdminRoot = pathname === "/admin" || pathname === "/admin/";
  const pageAllowed = canAccessAdminPage(role, pathname);

  return (
    <>
      <SignedOut>
        <Navigate to="/admin/login" replace />
      </SignedOut>
      <SignedIn>
        {!role ? (
          <AccessDeniedPage />
        ) : !pageAllowed && isAdminRoot ? (
          <Navigate to={defaultAdminPage(role)} replace />
        ) : (
          <SidebarLayout
            navbar={<Navbar />}
            sidebar={<AdminSidebar />}
          >
            <div className="w-full max-w-6xl">
              {pageAllowed ? <Outlet /> : <AccessDeniedPage reason="out-of-scope" />}
            </div>
          </SidebarLayout>
        )}
      </SignedIn>
    </>
  );
}
